import { styled } from '@mui/material/styles';
import PaymentPaypal from '../PaymentPaypal';

export const WrapperStyled = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;

export const PaymentPaypalStyled = styled(PaymentPaypal)`
  width: 100%;
`;
